import { PageHeader, PageShell } from '~/components/layout';
import { Tabs } from '~/components/ui';
import { useUrlParams } from '~/hooks/useUrlParams';

import {
  AnalyticsSourcePanel,
  AnalyticsSourceTabs,
  readAnalyticsScope,
  sourceChangePatch,
} from '~/components/pages/ai/analytics/AnalyticsFilters';
import AnalyticsOverviewTab from '~/components/pages/ai/analytics/AnalyticsOverviewTab';
import AnalyticsUserDataTab from '~/components/pages/ai/analytics/AnalyticsUserDataTab';

const TABS = [
  { id: 'overview', label: 'Overview' },
  { id: 'user-data', label: 'User data' },
];

/** Aggregate health and per-session data for one AI source at a time (overview.md "Routes"). */
export default function AnalyticsPage() {
  const url = useUrlParams();
  const tab = url.get('tab') === 'user-data' ? 'user-data' : 'overview';
  const filters = readAnalyticsScope(url.get);
  // Overview puts the source tabs on its Filters row; User data keeps its toolbar in the card.
  const sourceTabs = (
    <AnalyticsSourceTabs
      value={filters.source}
      onChange={(next) => url.set(sourceChangePatch(next))}
    />
  );

  return (
    <PageShell>
      <PageHeader
        title="Analytics"
        breadcrumbs={[{ label: 'AI' }, { label: 'Analytics' }]}
        testId="ai-analytics-page"
      />

      <Tabs
        ariaLabel="Analytics views"
        idPrefix="ai-analytics"
        activeId={tab}
        onChange={(id) => url.set({ tab: id === 'overview' ? null : id, session: null })}
        tabs={TABS}
      />

      <section
        role="tabpanel"
        id={`ai-analytics-panel-${tab}`}
        aria-labelledby={`ai-analytics-tab-${tab}`}
        className="space-y-6"
      >
        {tab === 'overview' ? (
          <AnalyticsOverviewTab sourceTabs={sourceTabs} />
        ) : (
          <>
            {sourceTabs}
            <AnalyticsSourcePanel source={filters.source}>
              <AnalyticsUserDataTab />
            </AnalyticsSourcePanel>
          </>
        )}
      </section>
    </PageShell>
  );
}
